import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { Plus, X, Save } from "lucide-react";

// Add/edit carrier form used by the Carrier Directory dialog.
export const CarrierForm = ({ form, setForm, updContact, addContact, removeContact, save, cancel }) => (
  <div className="space-y-3 border border-border rounded-lg p-4" data-testid="carrier-edit-form">
    <div className="grid grid-cols-2 gap-3">
      <div className="col-span-2">
        <Label className="text-xs font-bold uppercase text-[#57534E]">Name</Label>
        <Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="carrier-form-name" />
      </div>
      <div>
        <Label className="text-xs font-bold uppercase text-[#57534E]">Tier</Label>
        <Select value={String(form.tier)} onValueChange={(v) => setForm({ ...form, tier: v })}>
          <SelectTrigger data-testid="carrier-form-tier">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="1">Tier 1 — Heavy Equipment</SelectItem>
            <SelectItem value="2">Tier 2 — Regional</SelectItem>
            <SelectItem value="3">Tier 3 — Dry Van / Parts</SelectItem>
            <SelectItem value="0">Do Not Use</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label className="text-xs font-bold uppercase text-[#57534E]">Location</Label>
        <Input value={form.location} onChange={(e) => setForm({ ...form, location: e.target.value })} data-testid="carrier-form-location" />
      </div>
      <div className="col-span-2">
        <Label className="text-xs font-bold uppercase text-[#57534E]">Website</Label>
        <Input
          placeholder="carrier.com"
          value={form.website}
          onChange={(e) => setForm({ ...form, website: e.target.value })}
          data-testid="carrier-form-website"
        />
      </div>
      <div className="col-span-2">
        <Label className="text-xs font-bold uppercase text-[#57534E]">Contacts (for RFPs)</Label>
        <div className="mt-1 space-y-2" data-testid="carrier-form-contacts">
          {form.contacts.map((ct, idx) => (
            <div key={ct._key || idx} className="grid grid-cols-[1fr_1.3fr_1fr_auto] gap-2 items-center">
              <Input
                placeholder="Contact name"
                value={ct.name}
                onChange={(e) => updContact(idx, "name", e.target.value)}
                data-testid={`carrier-contact-name-${idx}`}
              />
              <Input
                type="email"
                placeholder="email@carrier.com"
                value={ct.email}
                onChange={(e) => updContact(idx, "email", e.target.value)}
                data-testid={`carrier-contact-email-${idx}`}
              />
              <Input
                type="tel"
                placeholder="Phone"
                value={ct.phone}
                onChange={(e) => updContact(idx, "phone", e.target.value)}
                data-testid={`carrier-contact-phone-${idx}`}
              />
              <Button
                variant="ghost"
                size="icon"
                className="h-8 w-8 text-red-600"
                onClick={() => removeContact(idx)}
                data-testid={`carrier-contact-remove-${idx}`}
              >
                <X className="h-4 w-4" />
              </Button>
            </div>
          ))}
          <Button
            variant="outline"
            size="sm"
            onClick={addContact}
            className="border-dashed border-[#F97316]/40 text-[#EA580C]"
            data-testid="carrier-contact-add"
          >
            <Plus className="h-3.5 w-3.5 mr-1" /> Add contact
          </Button>
        </div>
      </div>
      <div className="col-span-2">
        <Label className="text-xs font-bold uppercase text-[#57534E]">Notes</Label>
        <Input value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} data-testid="carrier-form-notes" />
      </div>
      <label className="col-span-2 flex items-center gap-2 cursor-pointer">
        <Checkbox checked={form.preferred} onCheckedChange={(v) => setForm({ ...form, preferred: !!v })} data-testid="carrier-form-preferred" />
        <span className="text-sm text-[#1C1917]">Preferred carrier (shown first when sending RFPs)</span>
      </label>
      <label className="col-span-2 flex items-center gap-2 cursor-pointer">
        <Checkbox checked={form.disabled} onCheckedChange={(v) => setForm({ ...form, disabled: !!v })} data-testid="carrier-form-disabled" />
        <span className="text-sm text-[#1C1917]">Disabled (Do Not Use)</span>
      </label>
    </div>
    <div className="flex gap-2">
      <Button onClick={save} className="bg-[#F97316] hover:bg-[#EA580C] text-white" data-testid="carrier-form-save">
        <Save className="h-4 w-4 mr-1.5" /> Save
      </Button>
      <Button variant="outline" onClick={cancel} data-testid="carrier-form-cancel">
        <X className="h-4 w-4 mr-1.5" /> Cancel
      </Button>
    </div>
  </div>
);
